import { forwardRef, Fragment, Suspense, useState } from 'react';
import { useSelector } from "react-redux";
import ControlBar from "components/organisms/ControlBar";
import ToolHeader from "components/organisms/ToolHeader";
import DesignContainer from "components/organisms/DesignContainer";
import NavContainer from "components/organisms/NavContainer";
import Spotlight from 'components/services/Spotlight';


const Page = forwardRef((props, ref) => {
  const projectName = useSelector(state => state.container.project.name);
  const [silentSave, setSilentSave] = useState(false);
  return (
    <Fragment>
      <div className="position-relative w-100 h-100">
        <div className='container-fluid d-flex flex-column h-100' >
          <Suspense>
            <ToolHeader ref={ref} project={projectName} silentSave={silentSave} setSilentSave={setSilentSave}></ToolHeader>
            <ControlBar silentSave={silentSave} setSilentSave={setSilentSave} />
            <div className={`row justify-content-${props.showChild ? 'between' : 'end'} h-100`}>
              {props.showChild && <DesignContainer />}
              <NavContainer />
            </div>
          </Suspense>
        </div>
      </div>
      <Spotlight />
    </Fragment>
  )
})

export default Page;